export default __webpack_public_path__ + "static/media/02_photo.dbd4e9b7.jpg";